<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create Video</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">File/Link *</label>
                      <div class="col-md-10">
                        <FileUploader
                          v-model="videoFile"
                          check-type="media_video"
                          path-prefix="vid"
                          :dropzone-options="dropzoneOptions"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Thumbnail</label>
                  <div class="col-md-10">
                    <image-uploader
                      @changeFile="coverUploaded"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Video Series</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.series"
                      :default-options="defaultOptions.series"
                      :search-function="seriesSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Video has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SelectRemote from '@/global/components/SelectRemote';
import FileUploader from '@/global/components/FileUploader/Index';
import { URL, FILE } from '@/global/components/FileUploader/constants';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import config from '../../../config';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';

export default {
  name: 'VideoNew',

  components: {
    'select-remote': SelectRemote,
    FileUploader,
    referencer: Referencer,
    terms: Terms,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests],

  data() {
    return {
      videoFile: null,
      entity: {
        title: null,
        body: null,
        summary: null,
        mediaFile: null,
        cover: null,
        series: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: '',
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 10240,
        addRemoveLinks: true,
        autoProcessQueue: false,
        acceptedFiles: 'video/*,video/x-matroska,.mkv',
        accept() {},
      },
    };
  },

  mounted() {
    this.$_getDefaultSeries();
  },

  methods: {
    seriesSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/video-series?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    isEntityValid() {
      const { videoFile } = this;
      const filelds = [
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias, type: 'path' },
      ];
      if (videoFile.uploadType === 'url') {
        filelds.push({ name: 'File', value: videoFile.fileLink, type: 'required' });
      } else if (videoFile.uploadType === 'file') {
        filelds.push({ name: 'File', value: Object.values(videoFile.filesDictionary).length, type: 'required' });
      } else if (videoFile.uploadType === 'youtube') {
        filelds.push({ name: 'File', value: videoFile.youtube, type: 'required' });
      } else if (videoFile.uploadType === 'vimeo') {
        filelds.push({ name: 'File', value: videoFile.vimeo, type: 'required' });
      }
      return this.$_validate(filelds);
    },
    coverUploaded(file) {
      this.entity.cover = file;
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      if (this.videoFile.uploadType === 'file') {
        postFormData.append('chunkedFile', true);
      }
      const { filesDictionary } = this.videoFile;
      Object.keys(filesDictionary).forEach((quality) => {
        if (filesDictionary[quality].type === URL && filesDictionary[quality].linkStatus === 'ok') {
          postFormData.append(`selectel_file_url_${quality}`, filesDictionary[quality].url);
        }
      });
      if (this.videoFile.youtube) {
        postFormData.append('youtube_link', JSON.stringify({
          link: this.videoFile.youtube,
          active: this.videoFile.uploadType === 'youtube',
        }));
      }
      if (this.videoFile.vimeo) {
        postFormData.append('vimeo_link', JSON.stringify({
          link: this.videoFile.vimeo,
          active: this.videoFile.uploadType === 'vimeo',
        }));
      }
      postFormData.append('cover', this.entity.cover);
      if (this.entity.series) postFormData.append('series_id', this.entity.series.id);
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}media/video`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { filesDictionary } = this.videoFile;
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const { acceptedFiles } = this.dropzoneOptions;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        if (filesDictionary) {
          Object.keys(filesDictionary).forEach((quality) => {
            const { type, file } = filesDictionary[quality];
            if (type !== FILE || !file) {
              return;
            }
            this.$store.dispatch('uploadManager/startUpload', {
              apiHost: host,
              apiPrefix: prefix,
              entityId: response.data.id,
              files: [file],
              token,
              acceptedFiles,
              contentType: response.data.content_type,
              quality,
            });
          });
        }
        window.location.hash = `#/admin/content/media_video/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create video query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?6b380ea3